import React from 'react'

export default function PDFMetaData(props) {
  const { className } = props

  return (
    <div className={className ? className : ''}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="currentColor"
        viewBox="0 0 32 36"
      >
        <path
          fill="currentColor"
          fill-opacity=".1"
          d="M30.3 8.8V32c0 1.8-1.5 3.2-3.2 3.2H5c-1.8 0-3.2-1.5-3.2-3.2V4C1.8 2.2 3.2.7 5 .7h17.2c.5 0 1.1.2 1.4.6l6.1 6c.3.4.6.9.6 1.5Z"
          opacity=".1"
        />
        <path
          fill="currentColor"
          d="M30.2 6.8 23.8.6c-.3-.4-.9-.6-1.4-.6h-18C2.6 0 1 1.5 1 3.4v29.2C1 34.5 2.6 36 4.4 36h23.1c1.9 0 3.4-1.5 3.4-3.3V8.5c.1-.7-.2-1.3-.7-1.7Zm-.4 24.9c0 1.7-1.4 3.2-3.1 3.2H5.3c-1.7 0-3.1-1.4-3.1-3.2V4.3c0-1.7 1.4-3.2 3.1-3.2h16.5c.5 0 1 .2 1.4.6l5.9 5.8c.4.4.7 1 .6 1.6v22.6h.1Z"
        />
        <path
          fill="currentColor"
          d="M18.454 18.5c0-1.479-1.238-2.833-2.954-2.833-1.716 0-2.954 1.354-2.954 2.833s1.238 2.833 2.954 2.833c1.716 0 2.954-1.354 2.954-2.833Zm2.903 0a5.87 5.87 0 0 1-5.857 5.885A5.87 5.87 0 0 1 9.643 18.5a5.87 5.87 0 0 1 5.857-5.885 5.87 5.87 0 0 1 5.857 5.885Z"
        />
        <path
          fill="currentColor"
          d="M14.049 25.474V22.86c0-.843.65-1.526 1.451-1.526.802 0 1.451.683 1.451 1.526v2.615c0 .843-.65 1.526-1.451 1.526-.802 0-1.451-.683-1.451-1.526Zm-3.22-4.598a1.402 1.402 0 0 1 2.052.066 1.58 1.58 0 0 1-.062 2.156l-1.869 1.85a1.402 1.402 0 0 1-2.051-.066 1.581 1.581 0 0 1 .062-2.157l1.868-1.849Zm7.139.066a1.402 1.402 0 0 1 2.05-.066l1.87 1.85c.583.577.611 1.542.062 2.156a1.402 1.402 0 0 1-2.051.065l-1.87-1.849a1.581 1.581 0 0 1-.061-2.156Zm-6.873-3.968c.801 0 1.45.683 1.45 1.526s-.649 1.526-1.45 1.526H8.45c-.8 0-1.45-.683-1.45-1.526s.65-1.526 1.451-1.526h2.643Zm11.454 0c.801 0 1.451.683 1.451 1.526s-.65 1.526-1.451 1.526h-2.643c-.802 0-1.452-.683-1.452-1.526s.65-1.526 1.451-1.526h2.644Zm-13.392-4.75a1.402 1.402 0 0 1 2.05-.066l1.87 1.85a1.58 1.58 0 0 1 .062 2.156 1.402 1.402 0 0 1-2.051.065l-1.87-1.849a1.581 1.581 0 0 1-.061-2.156Zm10.483-.066a1.402 1.402 0 0 1 2.052.066 1.58 1.58 0 0 1-.062 2.156l-1.87 1.85a1.402 1.402 0 0 1-2.05-.066 1.581 1.581 0 0 1 .062-2.157l1.868-1.849Zm-5.591 1.983v-2.615c0-.843.65-1.526 1.451-1.526.802 0 1.451.683 1.451 1.526v2.615c0 .843-.65 1.526-1.451 1.526-.802 0-1.451-.683-1.451-1.526Z"
        />
      </svg>
    </div>
  )
}
